<template>
  <div class="px-4 pt-3 pb-4">
    <div
      v-for="data in items"
      :key="data.id"
      class="flex-row"
      @click="handleItem(data)"
    >
      <div
        class="scss-round-container d-flex flex-row mb-2 scss-click-effect">
        <expandable-list
          class="flex-grow-1"
          :border="data.promotion || data.futurePromotion">
          <expandable-list-header
            v-if="data.promotion || data.futurePromotion"
            :content="getPromotionHeader(data)"/>
          <expandable-list-item
            :imgUrl="data.image"
            :name="data.name"
            :processingTime="formatProcessingTime(data.type, data.service.processingTime)"
            :description="data.description"
            :originalPrice="data.futurePromotion ? data.futureOriginalPrice : data.originalPrice"
            :salePrice="data.futurePromotion ? data.futureSalePrice : data.salePrice"
            :hidePrice="hidePrice"
            :clickable="false"
          >
            <div class="d-flex flex-row align-items-center me-2">
              <icon-container
                :iconClass="'bi-plus-lg'"
                :cssClass="`style-border ${data.futurePromotion ? 'scss-not-allowed' : ''}`"
                @click.stop="handleItemSelection(data)"
                />
            </div>
          </expandable-list-item>
        </expandable-list>
      </div>
    </div>
    <div
      v-if="handleSeeAllButton"
      class="text-end fw-bold fst-italic mt-2"
      style="font-size: 14px"
    >
      <span class="scss-click-effect" @click="handleSeeAllButton"> See All >> </span>
    </div>
  </div>
</template>

<script>
import ExpandableList from "@/components/ExpandableList.vue";
import ExpandableListHeader from "@/components/ExpandableListHeader.vue";
import ExpandableListItem from "@/components/ExpandableListItem.vue";
import IconContainer from "@/components/IconContainer.vue";
import {
  formatProcessingTime,
  getPromotionHeader,
 } from "@/common/helpers/ProductHelper";

export default {
  name: "ServiceItem",
  props: {
    items: {
      type: Array,
      required: true,
    },
    hidePrice: {
      type: [Boolean, Number],
      default: false,
    },
    handleItem: {
      type: Function,
      required: true,
    },
    handleItemSelection: {
      type: Function,
      required: true,
    },
    handleSeeAllButton: {
      type: Function,
      required: false,
    },
  },
  components: {
    ExpandableList,
    ExpandableListHeader,
    ExpandableListItem,
    IconContainer,
  },
  methods: {
    formatProcessingTime,
    getPromotionHeader,
  },
};
</script>
